module.exports = __webpack_public_path__ + "static/img/eye_glass.1672bd81.png";